import { Box, Typography, LinearProgress } from '@mui/material';
import { useAtomValue } from 'jotai';
import { currentUserPointAtom, moonRushInfo, userWinRateAtom } from '../state';
import {
  EndWrapper,
  PrepareWrapper,
  RunningWrapper,
  WinRateWrapper,
} from './style';
import { useTranslation } from 'next-i18next';
import { RushGameStatus } from '../types';
import { showCelebrationAtom } from '@/components/features/casino/game-celebration/state';
import FilterVintageIcon from '@mui/icons-material/FilterVintage';
import useTheme from '@/theme/useTheme';
import InviteBtn from '@/components/features/casino/rush/InviteBtn';
import { useDownMd } from '@/components/features/casino/rush/hooks';

function formatMilliseconds(milliseconds: number) {
  const minutes = Math.floor(milliseconds / 1000 / 60);
  const seconds = Math.floor(milliseconds / 1000) % 60;
  const m = minutes < 10 ? '0' + minutes : minutes;
  const s = seconds < 10 ? '0' + seconds : seconds;
  return `${m}m:${s}s`;
}

const PreparingInfo = ({ sx, t, countdown }) => {
  return (
    <PrepareWrapper sx={sx}>
      <Typography variant="h5">{countdown.toFixed(0)}s</Typography>
      <Typography variant="h6">{t('Preparing Round')}</Typography>
    </PrepareWrapper>
  );
};
const EndInfo = ({ sx, t, winner = '' }) => {
  return (
    <EndWrapper sx={sx}>
      <Typography variant="h4">{t('Winner: ') + winner}</Typography>
      <Typography variant="h5">{t('Mining Completed')}</Typography>
    </EndWrapper>
  );
};
const WinRateBox = ({ theme, sx, t }) => {
  const winRate = useAtomValue(userWinRateAtom);
  const userPoint = useAtomValue(currentUserPointAtom);
  return (
    <WinRateWrapper>
      <Box
        sx={{
          ...sx,
          borderRadius: '8px',
          border: (theme) => theme.palette.border.normal,
          background: '#16161B',
          p: 1,
          width: '260px',
          [theme.breakpoints.down('md')]: {
            width: '100%',
            fontSize: '12px',
            mt: 1,
            ml: 2,
            mr: 2,
          },
        }}
      >
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          <Typography
            variant="body2"
            sx={{
              display: 'flex',
              alignItems: 'center',
              fontWeight: 'bold',
            }}
          >
            {t('Win Rate:')} {winRate}%
          </Typography>
          <Typography
            variant="body2"
            sx={{
              fontWeight: 'bold',
            }}
          >
            {t('points:')} {userPoint}
          </Typography>
        </Box>
        <Box
          sx={{
            mt: 1,
          }}
        >
          <LinearProgress variant="determinate" value={winRate} />
        </Box>
      </Box>
    </WinRateWrapper>
  );
};
export default function RushStateInfo() {
  const { gameStatus, timer, countdown, winner } = useAtomValue(moonRushInfo);
  const { t } = useTranslation();
  const showCelebration = useAtomValue(showCelebrationAtom);
  const isRush = gameStatus === RushGameStatus.RUSH;
  const { theme } = useTheme();
  const downMd = useDownMd();
  const sx = showCelebration
    ? { opacity: 0 }
    : {
        opacity: 1,
      };
  switch (gameStatus) {
    case RushGameStatus.PREPARING:
      return <PreparingInfo sx={sx} t={t} countdown={countdown} />;
    case RushGameStatus.NORMAL:
    case RushGameStatus.RUSH:
      return <>{downMd && <InviteBtn />}</>;
    case RushGameStatus.END:
      return <EndInfo sx={sx} t={t} winner={winner?.name} />;
    default:
      return null;
  }
}
